"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var premiumPrograms = ['precoa', 'hlc', 'parklawn', 'selected'];
var _default = premiumPrograms;
exports.default = _default;